import { IData } from "./BulkNetlinkingUtils";
import NetlinkingOrderInfoFrom from "./NetlinkingOrderInfoFrom";

export type IHandleAllNetlinkingOrderInfo = (
    id: number,
    index: number,
    field: "keyword" | "date" | "anchor",
    value: string
) => void;

export interface INetlinkingOrderInfoFrom {
    data: IData[];
    handleAllNetlinkingOrderInfo: IHandleAllNetlinkingOrderInfo;
}
const AllNetlinkingOrderInfoFrom = (props: INetlinkingOrderInfoFrom) => {
    const { data, handleAllNetlinkingOrderInfo } = props;

    return (
        <>
            {data.map((el, elIndex) => (
                <>
                    {el.netlinkingOrderInfo && (
                        <NetlinkingOrderInfoFrom
                            key={elIndex}
                            url={el.url}
                            netlinkingOrderInfo={el.netlinkingOrderInfo}
                            handleNetlinkingOrderInfo={(index, field, value) =>
                                handleAllNetlinkingOrderInfo(el.id, index, field, value)
                            }
                        />
                    )}
                </>
            ))}
        </>
    );
};

export default AllNetlinkingOrderInfoFrom;
